<template>
  <div class="wid-1200">
    <!--面包屑-->
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <template v-if="$route.params.uid">
        <el-breadcrumb-item>理论学习</el-breadcrumb-item>
        <el-breadcrumb-item>学图谱</el-breadcrumb-item>
        <el-breadcrumb-item>{{ type }}</el-breadcrumb-item>
      </template>
      <template v-else-if="keyword">
        <el-breadcrumb-item>检索结果</el-breadcrumb-item>
        <el-breadcrumb-item>检索条件：{{ select }}="{{ keyword }}"</el-breadcrumb-item>
      </template>
    </el-breadcrumb>
    <el-tabs
      :tab-position="tabPosition"
      v-model="activeName"
      @tab-click="handleClick"
      :class="{'only-con':$route.params.activeName==9}"
    >
      <el-tab-pane v-for="(item,i) in menuList" :key="item.uid" :class="{'only-con':$route.params.activeName==9}" :disabled="activeName==i" v-loading="listLoading" style="position: relative;">
        <div class="label-out" slot="label" v-if="$route.params.activeName!=9">
          <span class="label">{{ item.columnName }}</span>
        </div>
        
        <el-empty v-if="!listLoading && !list.length"></el-empty>
        <template v-else>
          <div
            class="list-top"
            v-if="activeName !== '6' && list.length && !listLoading"
          >
            <span class="sort"
            @click="sort">
              排序：
              <span class="order"
                >发表时间
                <i class="el-icon-bottom" v-if="desc"></i>
                <i class="el-icon-top" v-else></i>
              </span>
            </span>
            <span class="total">共{{ total }}条</span>
          </div>
          <!-- 相关著作 -->
          <ul class="writing-list" v-if="activeName === '7'">
            <li v-for="item in list" :key="item.id">
              <img
                :src="item.imageUrl"
                alt=""
              />
              <div class="con">
                <span class="title">{{ item.title }}</span>
                <span class="author">作 (编) 者：{{ item.author }}</span>
                <div class="brief" v-if="false">
                  简介：《习近平谈治国理政》一书收入了习近平总书记在2012年11月15日至2014年6月13日这段时间内的讲话、谈话、演讲、答问、批示、贺信等79篇，分为18个专题。为帮助各国读帮助各国读者了解中国社会制度和历史文化，本书作了必要注为帮助各国读者了解中国社会制度和历史文化解中国社会制度和历史文化，本书作了必要注...
                </div>
              </div>
            </li>
          </ul>
          <!-- 重要论述 -->
          <ol class="list" v-else-if="activeName === '1'">
            <li v-for="(item, i) in list" :key="i">
              <div
                class="con"
                v-html="$options.filters.keywordHighlight(item.content, keyword, i,pageIndex)"
              ></div>
              <div
                class="info"
                v-html="$options.filters.keywordHighlight(item.source, keyword)"
              ></div>
            </li>
          </ol>
          <!-- 视频课程 -->
          <el-row v-else-if="activeName === '6'" :gutter="20" v-loading="listLoading">
            <el-col :span="6" v-for="o in list" :key="o.id">
              <el-card :body-style="{ padding: '0px' }">
                <!-- <a style="display: block" :href="o.nodeUrl" target="_blank"> -->
                  <img :src="o.smallImageLink" class="image" />
                  <div>
                    <span class="card-title" :title="o.title">{{
                      o.title
                    }}</span>
                    <div class="bottom">
                      <div class="bottom1 clearfix">
                        <span class="name">
                          <svg class="icon" aria-hidden="true">
                            <use xlink:href="#iconperson"></use>
                          </svg>
                          {{ o.videoSpeaker }}
                        </span>
                        <time class="time">
                          <svg class="icon" aria-hidden="true">
                            <use xlink:href="#icontime"></use>
                          </svg>
                          {{ o.pubDate }}
                        </time>
                      </div>
                      <span class="info"
                        >{{ o.source }}</span
                      >
                    </div>
                  </div>
                <!-- </a> -->
              </el-card>
            </el-col>
          </el-row>
          <div
            class="list-container"
            v-else v-loading="listLoading">
            <el-table
              v-show="!listLoading"
              :show-overflow-tooltip="true"
              :data="list"
              style="width: 100%"
              v-loading="listLoading"
            >
              <el-table-column header-align="center" label="篇名">
                <template slot-scope="scope">
                  <a v-if="select==='主题' || select==='篇名'" :href="scope.row.nodeUrl" target="_blank" v-html="$options.filters.keywordHighlight(scope.row.title, keyword)"></a>
                  <a v-else :href="scope.row.nodeUrl" target="_blank">{{ scope.row.title }}</a>
                </template>
              </el-table-column>
              <el-table-column align="center" label="作者">
                <template slot-scope="scope">
                  <!-- <span v-if="select==='作者'" v-html="$options.filters.keywordHighlight(scope.row.author.replace(/;$/, ""), keyword)"></span> -->
                  <span v-if="select==='作者'" v-html="$options.filters.keywordAuthorHighlight(scope.row.author, keyword)"></span>
                  <span v-else>{{ scope.row.author.replace(/;$/, "") }}</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="来源"
                width="150"
              >
              <template slot-scope="scope">
                <span v-if="select==='文献来源'" v-html="$options.filters.keywordHighlight(scope.row.source, keyword)"></span>
                <span v-else>{{ scope.row.source }}</span>
              </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="pubDate"
                label="发表时间"
                width="100"
              >
              </el-table-column>
            </el-table>
          </div>
        </template>
        <div class="page">
          <el-pagination
            v-show="!listLoading && list.length"
            background
            :current-page.sync="pageIndex"
            hide-on-single-page
            layout="prev, pager, next"
            :total="total"
            @current-change="changePage"
          />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabPosition: "left",
      activeName: "0",
      menuList: [],
      uidList: [],
      list: [],
      total: 0,
      listLoading: false,
      pageIndex: 1,
      desc: true, // 默认降序
      params:{},
      uid:'',
      type:'',
      keyword:'',
      select:'',
    };
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.axios
        .get(
          "data/custom/classType?uid=2890042f-e49d-43e7-99b7-c65a15257e5d&pageNum=1&pageSize=10"
        )
        .then((res) => {
          if (res.status == 200) {
            let menuList = res.data.rows.filter((item,i) => i<6);
            this.menuList = menuList
            if(this.$route.params.activeName) {
              this.menuList = [menuList[this.$route.params.activeName]]
              this.type = menuList[this.$route.params.activeName].columnName
              this.uid = this.$route.params.uid
            }else {
              this.uidList = this.menuList.map((item) => item.uid)
              this.uid = this.uidList[Number(this.activeName)]
            }
            this.getList();
          } else {
            this.$message.error("获取失败！");
          }
        });
    },
    sort() {
      this.pageIndex = 1
      this.desc = !this.desc;
      this.getList();
    },
    getList() {
      this.keyword = this.$route.params.uid ? '' : window.localStorage.getItem('keyword')
      this.select = this.$route.params.uid ? '' : window.localStorage.getItem('select')
      console.log(this.select==='作者')
      this.listLoading = true;
      let params = {
        uid: this.uid,
        keyWords: this.keyword,
        pageNum: this.pageIndex,
        pageSize: this.activeName == this.menuList.length - 2 ? 16 : 10, // 视频课程每页展示16条
        sign: "更多",
      };
      this.params = this.activeName === "6" ? params : { ...params, pubDateSort: this.desc ? "desc" : "asc" }
      if(this.select) this.params = {...this.params, name:this.select}
      this.axios
        .post(
          "data/cnki/getKbaseList",
          {...this.params}
        )
        .then((res) => {
          this.listLoading = false;
          if (res.status == 200) {
            this.total = res.data.total;
            this.list = res.data.rows;
          } else {
            this.$message.error("获取失败！");
          }
        });
    },
    changePage(n) {
      this.pageIndex = n;
      this.getList({ ...this.params, pageCurrent: n });
    },
    handleClick(tab, event) {
      this.pageIndex = 1;
      this.uid = this.uidList[Number(this.activeName)];
      this.list = []; // 清空数据列表
      this.listLoading = true; // 设置加载状态为true
      this.getList();
    },
  },
  filters: {
    keywordHighlight: function (value, keyword, i,pageIndex) {
      // if (!value || !keyword) return value.replace(/<p>(.*?)<\/p>/g, `<p>${i + 1}. $1</p>`);
      if (!value || !keyword) return (i==0 || i) ? `${(pageIndex-1)*10 + i +1}.${value}` : value
      return (i==0 || i) ? `${(pageIndex-1)*10 + i +1}.${value}`.replace(new RegExp("(" + keyword + ")", "ig"), `<span class="hightlight-red">$1</span>`) : value.replace(new RegExp("(" + keyword + ")", "ig"), `<span class="hightlight-red">$1</span>`)
      return value.replace(/<p>(.*?)<\/p>/g, `<p>${i + 1}.$1</p>`).replace(new RegExp("(" + keyword + ")", "ig"), `<span class="hightlight-red">$1</span>`);
    },
    keywordAuthorHighlight: function (value, keyword) {
      // if (!value || !keyword) return value.replace(/<p>(.*?)<\/p>/g, `<p>${i + 1}. $1</p>`);
      if (!value || !keyword) return value.replace(/;$/, "")
      return value.replace(/;$/, "").replace(new RegExp("(" + keyword + ")", "ig"), `<span class="hightlight-red">$1</span>`)
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .only-con{
    .el-tabs__header{
      display: none;
    }
  }
  .hightlight-red {
    color: #de1c26;
  }
  .el-tabs--left .el-tabs__nav-wrap.is-left:after {
    height: 0;
  }
  .el-tabs__active-bar {
    height: 0 !important;
  }
  .el-tabs--left .el-tabs__header {
    // border: 1px solid #fae0e0;
    // padding: 20px;
    // height: 470px;
    margin-bottom: 20px;
    &.is-left {
      margin-right: 20px;
    }
  }
  .el-tabs__item {
      height: auto;
      line-height: 1;
      padding-left: 18px;
      padding-right: 18px;
      text-align: center !important;
      &:not(:empty):nth-child(2){
        padding-top: 18px;
        border-top: 1px solid #fae0e0;
      }
      &:not(:empty):last-child{
        padding-bottom: 18px;
        border-bottom: 1px solid #fae0e0;
      }
      border-left: 1px solid #fae0e0;
      border-right: 1px solid #fae0e0;
    .label-out {
      padding: 15px 0 0 40px;
      background: url(../../assets/images/result_l_bg.png) no-repeat;
      margin-top: -0.7px;
    }
    span {
      display: block;
      background: #ffe6e7;
      color: #383636;
      font-size: 16px;
      height: 45px;
      line-height: 45px;
      padding: 0 39px;
    }
    &.is-active {
      .label {
        background: #de1c26;
        color: #ffffff;
      }
      .label-out {
        background-image: url(../../assets/images/result_l_cur_bg.png);
      }
    }
  }

  .el-table {
    color: #000;
    thead {
      color: #383636;
    }
    th.el-table__cell {
      background-color: #fcc8c8;
    }
  }
}
.list-top {
  display: flex;
  justify-content: space-between;
  background: #fff5f5;
  border: 1px solid #fae0e0;
  height: 60px;
  line-height: 60px;
  font-size: 16px;
  padding: 0 20px;
  .sort {
    cursor: pointer;
  }
  .order {
    color: #de1c26;
  }
}
.list-container {
  min-height: 300px;
}
.list {
  li {
    font-size: 14px;
    padding: 15px 0 10px;
    border-bottom: 1px dotted #b1aeae;
    line-height: 1.6;
    .con{
      user-select: none;
    }
    &:last-child{
      border-bottom: none;
    }
    .info {
      color: #898989;
      margin-top: 5px;
      text-align: right;
      .highlight {
        color: #c6a0a2;
      }
    }
  }
}
.page {
  text-align: center;
  margin: 20px 0;
  .el-pagination {
    display: inline-block;
    margin-bottom: 30px;
  }
}
.el-col {
  margin-bottom: 20px;
  .time {
    font-size: 13px;
    color: #999;
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
    background: #fff9f9;
    padding: 5px 10px;
    font-size: 14px;
    line-height: 1.6;
    color: #898989;
    border-top: 1px solid #fae0e0;
    .bottom1 {
      .name {
        float: left;
      }
      .time {
        float: right;
      }
    }
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    height: 150px;
    display: block;
  }
  .card-title {
    font-size: 16px;
    padding: 0 10px;
    height: 48px;
    line-height: 48px;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both;
  }
}
.writing-list li {
  display: flex;
  color: #000;
  font-size: 14px;
  border-bottom: 1px dotted #b1aeae;
  padding: 20px 0;
  float: left;
  width: 50%;
  img {
    width: 141px;
    height: 180px;
    margin-right: 20px;
  }
  .title {
    font-size: 17px;
    display: block;
    margin-bottom: 10px;
  }
  .author {
    display: block;
    margin-bottom: 20px;
  }
  .brief {
    color: #898989;
    line-height: 1.6;
  }
}
</style>